import { Link } from '@material-ui/core'
import { PRESCRIPTION_FORM } from '../../constants'
import { ContentBlock, ContactLink } from '../components'

export default function PrescriptionInvalid() {
  return (
    <ContentBlock title="Invalid Rx" variant="warn">
      We have received an invalid prescription and are working with your
      healthcare provider to get it corrected. If we can't get this sorted with
      your provider, we will need you to bring our{' '}
      <Link download href={PRESCRIPTION_FORM} style={{ fontWeight: 'bold' }}>
        prescription form
      </Link>{' '}
      to an upcoming appointment. All fields need to be filled in by your
      provider and you can send the completed form to{' '}
      <ContactLink variant="rx" />.
    </ContentBlock>
  )
}
